<template>
  <div class="notification-badge" @click="$emit('click')">
    <span class="icon iconfont icon-notification"></span>
    <div v-if="unreadCount > 0" class="badge">{{ formattedCount }}</div>
  </div>
</template>

<script>
import { getUnreadCount } from '@/api/friendRequest';

export default {
  name: 'NotificationBadge',
  data() {
    return {
      unreadCount: 0,
      timer: null
    };
  },
  computed: {
    formattedCount() {
      return this.unreadCount > 99 ? '99+' : this.unreadCount;
    }
  },
  created() {
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.fetchUnreadCount();
      // Poll every 30 seconds
      this.timer = setInterval(this.fetchUnreadCount, 30000);
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchUnreadCount() {
      getUnreadCount()
        .then(response => {
          this.unreadCount = response || 0;
        })
        .catch(() => {
          // Silently fail
          this.unreadCount = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-badge {
  position: relative;
  display: inline-block;
  cursor: pointer;
  
  .icon {
    font-size: 22px;
  }
  
  .badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 10px;
    font-size: 12px;
    padding: 0 6px;
    min-width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
}
</style> 